<template>
    <div class="calculator">
        <b-card class="product-card">
            <b-card-header class="bg-white border-bottom-0 px-0 pb-0 pt-0">
                <b-row>
                    <b-col cols="12"
                           md="8"
                    >
                        <h5 class="ml-1 mb-0">
                            <i class="fa fa-cube mr-1 text-primary"></i>
                            <span class="font-weight-bold">{{ product.name }}</span>
                        </h5>
                        <div class="d-flex flex-wrap align-items-center text-muted ml-4">
                            <div class="mr-3"
                                 v-if="!!product.state"
                            >
                                <i class="fa fa-flask mr-1"></i>
                                <span>{{ product.state.lista }}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap align-items-center text-muted ml-4">
                            <div>
                                <i class="fa fa-building mr-1"></i>
                                <span>{{ product.company.nombre }}</span>
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12"
                           md="4"
                           class="d-flex flex-wrap justify-content-md-end align-items-center mt-2 mt-md-0"
                    >
                        <b-button variant="outline-primary"
                                  size="sm"
                                  class="mr-2 float-right"
                                  @click="openModalForEdition"
                        >
                            <i class="fa fa-pencil"></i> Editar
                        </b-button>
                        <b-button variant="light"
                                  size="sm"
                                  to="/calculadora/productos"
                        >
                            <i class="fa fa-arrow-left"></i> Volver
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-row>
                <b-col>
                    <hr>
                </b-col>
            </b-row>

            <b-tabs nav-class="modern-tabs-nav"
                    active-nav-item-class="modern-tab-active"
                    lazy
                    fill
                    justified
                    pills
                    v-model="selected_tab"
            >
                <b-tab v-for="(tab, i) in tabs"
                       :key="i"
                       :disabled="!propertiesFilled && tab.text !== 'Propiedades'"
                >
                    <template #title>
                        <div class="modern-tab-content">
                            <div class="icon-container">
                                <img :src="`./calculator/icons/${tab.icon}.png`"
                                     class="menu-icon-tabs"
                                     :alt="tab.text"
                                />
                            </div>
                        </div>
                        <div class="text-tab d-none d-md-block">
                            {{ tab.text }}
                        </div>
                    </template>
                </b-tab>
            </b-tabs>

            <hr class="my-2">

            <!-- Modal de creación y edición -->
            <modal ref="modal_product"/>

            <!-- Modal de creación de fabricante -->
            <modal_manufacturer/>

            <component v-if="tabs[selected_tab]"
                       v-bind:is="tabs[selected_tab].component"
                       :component="tabs[selected_tab].component"
                       :ref="tabs[selected_tab].icon"
            />

            <modal_definitions/>

            <b-button to="/calculadora/productos"
                      size="sm"
                      variant="secondary"
                      class="mt-2"
            >
                <i class="fa fa-reply fa-lg"/> Volver
            </b-button>
        </b-card>
    </div>
</template>

<script>

import modal from '../modal.vue';
import files from './files/index';
import health from './health/index';
import physical from './physical/index';
import properties from './properties/index';
import environment from './environment/index';
import composition from './composition/index';
import justification from './justification/index';
import classification from './classification/index.vue';
import modal_manufacturer from '../modal_manufacturer';
import modal_definitions from '../components/modal_definitions';

import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'index',
    components: {
        modal_manufacturer,
        modal,
        files,
        health,
        physical,
        properties,
        environment,
        composition,
        justification,
        classification,
        modal_definitions
    },
    data() {
        return {
            selected_tab: 0,
            tabs: [
                {
                    text: 'Propiedades',
                    component: properties,
                    icon: 'properties'
                },
                {
                    text: 'Composición',
                    component: composition,
                    icon: 'composition'
                },
                {
                    text: 'Peligros Físicos',
                    component: physical,
                    icon: 'physical'
                },
                {
                    text: 'Peligros para la Salud',
                    component: health,
                    icon: 'health'
                },
                {
                    text: 'Peligros para el Medio Ambiente',
                    component: environment,
                    icon: 'environment'
                },
                {
                    text: 'Clasificación',
                    component: classification,
                    icon: 'classification'
                },
                {
                    text: 'Justificación clasificación',
                    component: justification,
                    icon: 'justification'
                },
                {
                    text: 'Documentos',
                    component: files,
                    icon: 'documents'
                }
            ],
        };
    },
    computed: {
        ...mapState('calculator', [
            'product'
        ]),
        propertiesFilled() {
            for (const key in this.product.properties) {
                if (this.product.properties[key] === null || this.product.properties[key] === '') {
                    return false;
                }
            }
            return true;
        }
    },
    async created() {
        const product_id = this.$route.params.product_id;
        const company_id = this.$route.params.company_id;

        this.setOnlyView(!!this.$route.params.view);

        if (!!product_id && !!company_id) {
            await this.getProduct({product_id, company_id});
            await this.getDangers();
            await this.getCategories();
            await this.getDangerClasses();

            this.$refs.properties.validate();
        } else {
            await this.$router.push('/calculadora/productos');
        }
    },

    methods: {
        ...mapActions('calculator', [
            'getDangers',
            'getProduct',
            'getCategories',
            'getComponents',
            'getDangerClasses',
            'getMeasureUnitsCl50'
        ]),
        ...mapMutations('calculator', [
            'setAction',
            'setModalShow',
            'setOnlyView',
            'setProduct',
            'setManufacturers'
        ]),
        openModalForEdition() {
            let product = JSON.parse(JSON.stringify(this.product));
            this.$refs.modal_product.change = false;
            this.setAction('Editar');
            this.setModalShow(true);
            this.setProduct(product);
            if (product.manufacturer) {
                this.setManufacturers([product.manufacturer]);
            } else {
                this.setManufacturers([]);
            }
        },
    }
};
</script>

<style lang="scss"
       src="../../../assets/calculator.scss"
/>

<style lang="scss">

.calculator {
    .product-card {
        box-shadow: 0 0.125rem 1.25rem rgba(0, 0, 0, 0.2) !important;
        border: 1px solid #d0d0d0;
        border-radius: 10px;
    }

    .modern-tab-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5px 0 0 0;
        transition: all 0.3s ease;
    }

    .icon-container {
        background-color: #e0e0e0;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
        transition: all 0.3s ease;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .modern-tab-content:hover .icon-container {
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }

    .modern-tab-content i {
        font-size: 20px;
        color: #6c757d;
    }

    .modern-tab-active .icon-container {
        background-color: #1a94c0;
    }

    .modern-tabs-nav .nav-link {
        background-color: #f4f4f4;
    }

    .modern-tabs-nav .nav-link.active {
        background-color: #ffffff;
    }

    .modern-tab-active .text-tab {
        color: #1a94c0;
    }

    .text-tab {
        color: #5d5d5d;
        font-size: 12px;
        line-height: 16px;
        height: 34px;
        align-content: center;
        overflow: hidden;
    }

    .modern-tab-active .modern-tab-content span {
        color: #1a94c0;
        font-weight: 600;
    }

    .nav-fill .nav-link.active {
        border-top: 3px solid #1a94c0;
    }

    .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
        color: #383838;
    }

    .nav-pills .nav-link, .nav-pills .show > .nav-link {
        color: #383838;
        border-top: 3px solid #c4c4c4;
    }

    .menu-icon-tabs {
        height: 25px;
    }

    @media (max-width: 576px) {
        .icon-container {
            width: 32px;
            height: 32px;
        }

        .menu-icon-tabs {
            height: 19px;
        }

        .nav-link {
            padding: 2px 5px;
            margin: 0 0.1rem;
        }
    }
}

</style>
